import React from "react";
import { Navigate } from "react-router-dom";

export const isLoggedIn = () => !!localStorage.getItem("token");
export const getUser = () => JSON.parse(localStorage.getItem("user") || "null");

/* -------------------------
   1) Giriş yapmış kullanıcı
--------------------------*/
export const PrivateRoute = ({ children }) => {
  if (!isLoggedIn()) return <Navigate to="/login" />;
  return children;
};

/* -------------------------
   2) Sadece admin
--------------------------*/
export const AdminRoute = ({ children }) => {
  const user = getUser();
  if (!isLoggedIn() || user?.role !== "admin") return <Navigate to="/404" />;
  return children;
};

/* -------------------------
   3) Ödemesi onaylanmış kullanıcı
--------------------------*/
export const ApprovedRoute = ({ children }) => {
  const user = getUser();
  if (!isLoggedIn() || !user?.isApproved) return <Navigate to="/odeme" />;
  return children;
};
